export default {
  setPower(ctx, power) {
    ctx.commit('setPower', power)
  },
  resetPower(ctx, power = 0) {
    ctx.commit('setPower', power)
  },
  setLevels(ctx, levels) {
    ctx.commit('setLevels', levels)
  },
  setHalls(ctx, halls) {
    ctx.commit('setHalls', halls)
  }
}
